module.exports = __webpack_public_path__ + "img/02.6e5e245b.jpg";